import moment from 'moment';

const MESSAGE_GROUP_MINUTES_TIME_RANGE = 2;

export const getAssociationByType = type => {
    switch (type) {
        case 'task':
            return 'Task';

        case 'file':
            return 'File';

        case 'thread':
            return 'Message';

        case 'doc':
            return 'Document';

        default:
            return 'Chat';
    }
}

export const getTypeKey = type => {
    switch (type) {
        case 'task':
            return 'task';

        case 'file':
            return 'file';

        case 'thread':
            return 'thread';

        case 'doc':
            return 'entity_key';

        default:
            return 'chat';
    }
}

export const getFetchKey = type => {
    switch (type) {
        case 'task':
            return 'task_id';

        case 'file':
            return 'file_id';

        case 'thread':
            return 'message_id';

        case 'doc':
            return 'entity_key';

        default:
            return 'chat_id';
    }
}

export const isSameTimeRange = (currentMessage, diffMessage) => {
    if (!diffMessage || !diffMessage.created_at) {
        return false;
    }

    const currentCreatedAt = moment(currentMessage.created_at)
    const diffCreatedAt = moment(diffMessage.created_at)

    if (!currentCreatedAt.isValid() || !diffCreatedAt.isValid()) {
        return false;
    }

    const duration = moment.duration(currentCreatedAt.diff(diffCreatedAt));
    const minutesDuration = Math.abs(duration.asMinutes());

    return minutesDuration < MESSAGE_GROUP_MINUTES_TIME_RANGE;
}

export const isSameUser = (currentMessage, diffMessage) => {
    if (!diffMessage) {
        return false;
    }

    if (currentMessage.bot_name && diffMessage.bot_name) {
        return currentMessage.bot_name === diffMessage.bot_name;
    }

    if (currentMessage.bot_name || diffMessage.bot_name) {
        return false;
    }

    if (currentMessage.subtype && diffMessage.subtype) {
        return true;
    }

    if (currentMessage.subtype || diffMessage.subtype) {
        return false;
    }

    return currentMessage.author === diffMessage.author;
}
